import { groupApi } from "src/api/group";
import { slice } from "src/slices/group";

// 1) 목록 조회
const getRegionGroups = () => async (dispatch) => {
  const groups = await groupApi.getRegionGroups();
  dispatch(slice.actions.getRegionGroups(groups));
};

// 2) 생성
const createRegionGroup = (dto) => async (dispatch) => {
  const created = await groupApi.createRegionGroup(dto);
  dispatch(slice.actions.createRegionGroup(created));
  return created;
};

// 3) 삭제
const deleteRegionGroup = (id) => async (dispatch) => {
  const deletedId = await groupApi.deleteRegionGroup(id);
  dispatch(slice.actions.deleteRegionGroup(deletedId));
};

// 4) 수정
const updateRegionGroup = (dto) => async (dispatch) => {
  const updated = await groupApi.updateRegionGroup(dto);
  dispatch(slice.actions.updateRegionGroup(updated));
};

// =====================
// AptFilter Thunks
// =====================

// 1) 목록 조회
const getAptFilters = () => async (dispatch) => {
  const filters = await groupApi.getAptFilters();
  dispatch(slice.actions.getAptFilters(filters));
};

// 2) 생성
const createAptFilter = (dto) => async (dispatch) => {
  const created = await groupApi.createAptFilter(dto);
  dispatch(slice.actions.createAptFilter(created));
};

// 3) 삭제
const deleteAptFilter = (id) => async (dispatch) => {
  const deletedId = await groupApi.deleteAptFilter(id);
  dispatch(slice.actions.deleteAptFilter(deletedId));
};

// 4) 수정
const updateAptFilter = (dto) => async (dispatch) => {
  const updated = await groupApi.updateAptFilter(dto);
  dispatch(slice.actions.updateAptFilter(updated));
};

// =====================
// AptGroup Thunks
// =====================

// 1) 목록 조회
const getAptGroups = () => async (dispatch) => {
  const groups = await groupApi.getAptGroups();
  dispatch(slice.actions.getAptGroups(groups));
};

// 2) 생성
const createAptGroup = (dto) => async (dispatch) => {
  const created = await groupApi.createAptGroup(dto);
  dispatch(slice.actions.createAptGroup(created));
};

// 3) 삭제
const deleteAptGroup = (id) => async (dispatch) => {
  const deletedId = await groupApi.deleteAptGroup(id);
  dispatch(slice.actions.deleteAptGroup(deletedId));
};

// 4) 수정
const updateAptGroup = (dto) => async (dispatch) => {
  const updated = await groupApi.updateAptGroup(dto);
  dispatch(slice.actions.updateAptGroup(updated));
};

export const thunks = {
  getRegionGroups,
  createRegionGroup,
  deleteRegionGroup,
  updateRegionGroup,
  getAptFilters,
  createAptFilter,
  deleteAptFilter,
  updateAptFilter,
  getAptGroups,
  createAptGroup,
  deleteAptGroup,
  updateAptGroup,
};
